{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -68.55556374761936,
              -27.056355204849858
            ],
            [
              -71.76138670025271,
              -27.69711389009081
            ],
            [
              -73.32149483064215,
              -34.70589062311604
            ],
            [
              -76.68093953263356,
              -44.43630156785239
            ],
            [
              -76.60566456343986,
              -53.675891316776884
            ],
            [
              -68.11017835050363,
              -57.00281571495548
            ],
            [
              -66.5027088858963,
              -55.29452606261076
            ],
            [
              -71.99444474806523,
              -50.856223022171626
            ],
            [
              -71.08489640521643,
              -45.914521273774724
            ],
            [
              -68.55556374761936,
              -27.056355204849858
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}